module.exports = __webpack_public_path__ + "static/media/facebook.a2e26e2c.svg";